import request from '../static/js/request'

export function getDictionary(data) {
  return request
    .get(`/mopa/api-answer-card/open/information/getDictionary`, {
      params: {
        parentId: data.join(',')
      }
    })
    .then((res) => res.data)
}

export function getAnswerVerion() {
  return request.get('/cms/upload/wbversion/version.json')
}

// 获取多个字典 { parentId: this.zdIds.version, recursiveTimes: 1 },
// recursiveTimes: 获取子节点级数
export function getzdChildV2(data) {
  return request({
    url: '/mopa/api-user-acl/open/dictionary/getAllChildren/v2',
    method: 'post',
    data: data
  })
}

export function getGradeCNJson() {
  return request.get('/cms/upload/grade/grade.json')
}
